import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CredibilityBar from './components/CredibilityBar';
import CareerSection from './components/CareerSection';
import PracticeSection from './components/PracticeSection';
import WhyChooseSection from './components/WhyChooseSection';
import FaqSection from './components/FaqSection';
import OfficeGallery from './components/OfficeGallery';
import ContactSection from './components/ContactSection';
import PressSection from './components/PressSection';
import MobileStickyCta from './components/MobileStickyCta';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <CredibilityBar />
      <CareerSection />
      <PressSection />
      <PracticeSection />
      <WhyChooseSection />
      <FaqSection />
      <OfficeGallery />
      <ContactSection />
      <Footer />
      <MobileStickyCta />
    </main>
  );
}